module.exports = __webpack_public_path__ + "static/media/bilguun.43bfe087.png";